import {useState} from 'react';

function useSelectedRoutes() {
  const [selectedRoute, setSelectedRoute] = useState('HOME');

  return {selectedRoute, setSelectedRoute};
}

export default useSelectedRoutes;
